export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_blessing-jobs/artifacts/9oi7rbei_blessing_logo.png";

export const COMPANY = {
  name: "Blessing Dienstleistungen",
  owner: "Marvin Blessing",
  slogan: "Alles rund ums Haus – Rundum-Sorglos-Paket",
  address: "Weiergarten 7a, 79423 Heitersheim",
  email: "info@blessing-dienstleistungen.de",
  phone: "+491773317285",
  phoneRaw: "+491773317285",
};

// Featured all-inclusive care packages – displayed prominently above single services
export const PACKAGES = [
  {
    key: "paket-privat",
    title: "Rundum-Sorglos-Paket · Ein-/Mehrfamilienhaus",
    subtitle: "Für Privateigentümer",
    tag: "Alle Leistungen inklusive",
    desc: "Ganzjährige Betreuung Ihres Grundstücks.",
    inclusions: [
      "Rasenmähen vorhandener Grünflächen",
      "Schneiden der Rasenkanten",
      "Bewässern",
      "Vertikutieren",
      "Rasensamen säen",
      "Unkraut-Entfernung auf Pflasterflächen",
      "Pflege und Sauberhaltung Pflasterflächen und Wegen",
      "Pflege und Sauberhaltung der Parkplätze",
      "Heckenschnitte",
      "Laubentfernung während der Herbstsaison",
      "Winterdienst – Räumung von Gehwegen und Parkplätzen",
      "Streudienst zur Unfallvermeidung",
    ],
  },
  {
    key: "paket-gewerbe",
    title: "Rundum-Sorglos-Paket · Gewerbe",
    subtitle: "Für Firmen & Verwaltungen",
    tag: "Alle Leistungen inklusive",
    desc: "Fester Ansprechpartner, planbare Kosten und ein repräsentatives Firmengelände – rund ums Jahr.",
    inclusions: [
      "Rasenmähen vorhandener Grünflächen",
      "Schneiden der Rasenkanten",
      "Bewässern",
      "Vertikutieren",
      "Rasensamen säen",
      "Unkraut-Entfernung auf Pflasterflächen",
      "Pflege und Sauberhaltung Pflasterflächen und Wegen",
      "Pflege und Sauberhaltung der Parkplätze",
      "Heckenschnitte",
      "Laubentfernung während der Herbstsaison",
      "Winterdienst – Räumung von Gehwegen und Parkplätzen",
      "Streudienst zur Unfallvermeidung",
    ],
  },
];

export const SERVICES = [
  {
    key: "rasen",
    title: "Rasen- & Grünflächenpflege",
    desc: "Mähen, Vertikutieren, Düngen, Nachsaat.",
    icon: "sprout",
  },
  {
    key: "hecke",
    title: "Heckenschnitt",
    desc: "Präziser Schnitt für dichte, gesunde Hecken.",
    icon: "scissors",
  },
  {
    key: "laub",
    title: "Laubentfernung",
    desc: "Laub sammeln, häckseln und entsorgen – für saubere, sichere Wege.",
    icon: "leaf",
  },
  {
    key: "winter",
    title: "Winterdienst",
    desc: "Räumen, Streuen, Verkehrssicherung – zuverlässig auch früh morgens.",
    icon: "snowflake",
  },
  {
    key: "sonder",
    title: "Sonderpflege",
    desc: "Individuelle Einzelleistungen auf Anfrage.",
    icon: "wand-2",
    items: [
      "Baumpflege & Baumfällung",
      "Fassadenreinigung",
      "Beet- & Bodenneuanlage",
      "Vertikutieren & Aerifizieren",
      "Zaun- & Weganlagen-Pflege",
      "Wildwuchs- & Unkrautbekämpfung",
      "Kleinreparaturen im Außenbereich",
      "Entsorgung von Grün- & Baumschnitt",
    ],
  },
  {
    key: "objekt",
    title: "Unkrautentfernung",
    desc: "Unkrautentfernung auf Pflasterflächen, Wegen und Parkplätzen.",
    icon: "shovel",
  },
];

export const EINZEL_LEISTUNGEN_OPTIONS = [
  "Rasenmähen vorhandener Grünflächen",
  "Schneiden der Rasenkanten",
  "Bewässern",
  "Vertikutieren",
  "Rasensamen säen",
  "Unkraut-Entfernung auf Pflasterflächen",
  "Pflege und Sauberhaltung Pflasterflächen und Wegen",
  "Pflege und Sauberhaltung der Parkplätze",
  "Heckenschnitte",
  "Laubentfernung während der Herbstsaison",
  "Winterdienst – Räumung von Gehwegen und Parkplätzen",
  "Streudienst zur Unfallvermeidung",
];

export const PAKET_LABEL = {
  privat: "Rundum-Sorglos-Paket (Ein-/Mehrfamilienhaus)",
  gewerbe: "Rundum-Sorglos-Paket (Gewerbe)",
};

// Backwards-compat (used in CRM quote dialog etc.)
export const LEISTUNGEN_OPTIONS = [
  PAKET_LABEL.privat,
  PAKET_LABEL.gewerbe,
  ...EINZEL_LEISTUNGEN_OPTIONS,
];
